export type Interactive = JSONConfigInteractive | LegacyJavascriptInteractive | ElmInteractive;

export type InteractiveTypeName =
  | JSONConfigInteractiveTypeName
  | LegacyJavascriptInteractiveTypeName
  | ElmInteractiveTypeName;

interface BaseInteractive {
  alias: string;
  type: InteractiveTypeName;
}

// TODO rename to SolvableMode
export type SolvableType = 'auto-check' | 'submittable';

// TODO rename to InteractiveMode
export type InteractiveType = 'playground' | SolvableType;

export interface ElmInitializationInstructions {
  modes: { [key: string]: ElmMode };
}

export interface ElmMode {
  module: ElmModule;
  validInteractiveTypes: InteractiveType[];
  usesDandy?: boolean;
  afterInitializing?: (app: ElmApp) => () => void;
}

export interface ElmModule {
  init: (config: { flags: any; node: HTMLElement }) => ElmApp;
}

export interface ElmApp {
  root: HTMLElement;
  ports: {
    [key: string]: {
      subscribe: (handler: (message: any) => void) => void;
      unsubscribe: (handler: (message: any) => void) => void;
      send: (message: any) => void;
    };
  };
}

export interface PortListenersSwitches {
  addListeners: () => void;
  removeListeners: () => void;
}

export type PortSetupFunction = (options: {
  interactiveApp: ElmApp;
  container: HTMLElement;
}) => Promise<PortListenersSwitches>;

/* JSON CONFIG TYPES */
export const JSON_CONFIG_TYPES = {
  parson: 'Parson',
  gridfill: 'Grid Fill',
  toggletags: 'Toggle Tags',
  neuralnetworks: 'Neural Networks',
  orderlogic: 'Order Logic',
  calcdoku: 'Calcdoku',
  hotcold: 'Hot Cold',
  hexapawn: 'Hexapawn',
  codex: 'Codex',
  numberbunchers: 'Number Bunchers',
  dronegame: 'Drone Game',
  sherlocksearch: 'Sherlock Search',
};

export type JSONConfigInteractiveTypeName = keyof typeof JSON_CONFIG_TYPES;

export interface JSONConfigInteractive extends BaseInteractive {
  type: JSONConfigInteractiveTypeName;
  json: string;
}

export const isJSONConfigInteractive = (
  interactive: Interactive,
): interactive is JSONConfigInteractive => {
  return interactive.type in Object.keys(JSON_CONFIG_TYPES);
};

/* LEGACY JAVASCRIPT TYPES */

export const LEGACY_JAVASCRIPT_TYPES = {
  coinflip: 'Coin Flip',
  escher: '3D Graph (Escher)',
  graph2d: '2D Graph',
  huygensclock: "Huygen's Clock",
  operatorsearch: 'Operator Search',
  quantumcircuit: 'Quantum Circuit',
};

export const isLegacyJavascriptInteractive = (
  interactive: Interactive,
): interactive is LegacyJavascriptInteractive => {
  return interactive.type in Object.keys(LEGACY_JAVASCRIPT_TYPES);
};

export type LegacyJavascriptInteractiveTypeName = keyof typeof LEGACY_JAVASCRIPT_TYPES;

export interface LegacyJavascriptInteractive extends BaseInteractive {
  type: LegacyJavascriptInteractiveTypeName;
  json: string;
}

export const GENERIC_ELM_ASSET_TYPE_NAME = 'genericElmAsset';

export type ElmInteractiveTypeName = typeof GENERIC_ELM_ASSET_TYPE_NAME;

export interface ElmInteractive extends BaseInteractive {
  type: ElmInteractiveTypeName;
  elm: string;
}

export const ALL_INTERACTIVE_TYPES = {
  ...JSON_CONFIG_TYPES,
  ...LEGACY_JAVASCRIPT_TYPES,
  [GENERIC_ELM_ASSET_TYPE_NAME]: 'Elm Asset',
};
